module.exports = __webpack_public_path__ + "img/thumbs-up.6508c8af.svg";